/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Adresse } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * AdresseService - axios parameter creator
 * @export
 */
export const AdresseServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Erstellt eine neue Adresse.
         * @summary Adresse
         * @param {Adresse} [adresse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdresse: async (adresse?: Adresse, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/adressen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adresse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Setzt eine Adresse auf \"unsichtbar\"
         * @summary Adresse
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdresse: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAdresse', 'id', id)
            const localVarPath = `/api/adressen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Adresse für die angegebene Fremdnummer
         * @summary Adresse
         * @param {string} fremdnummer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdresseByFremdnummer: async (fremdnummer: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fremdnummer' is not null or undefined
            assertParamExists('getAdresseByFremdnummer', 'fremdnummer', fremdnummer)
            const localVarPath = `/api/adressen/nr/{fremdnummer}`
                .replace(`{${"fremdnummer"}}`, encodeURIComponent(String(fremdnummer)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Adresse
         * @summary Adresse
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdresseById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdresseById', 'id', id)
            const localVarPath = `/api/adressen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert die Adresse des Mandanten für den aktuellen Benutzer
         * @summary Adresse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdresseOfCurrentMandant: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/adressen/currentMandantAdresse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert die aktuelle Adresse vom aktuellen Mandanten
         * @summary Adresse
         * @param {number} mandantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdresseOfMandant: async (mandantId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mandantId' is not null or undefined
            assertParamExists('getAdresseOfMandant', 'mandantId', mandantId)
            const localVarPath = `/api/adressen/mandantadresse/{mandantId}`
                .replace(`{${"mandantId"}}`, encodeURIComponent(String(mandantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Adressen für den angegebenen Mandanten
         * @summary Adresse
         * @param {number} mandantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdressenForMandant: async (mandantId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mandantId' is not null or undefined
            assertParamExists('getAdressenForMandant', 'mandantId', mandantId)
            const localVarPath = `/api/adressen/mandant/{mandantId}`
                .replace(`{${"mandantId"}}`, encodeURIComponent(String(mandantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Importiert eine Liste von Adresen für den angegebenen Mandanten (Admin-Funktion)
         * @summary Adresse
         * @param {number} mandantId 
         * @param {Array<Adresse>} [adresse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAdressen: async (mandantId: number, adresse?: Array<Adresse>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mandantId' is not null or undefined
            assertParamExists('importAdressen', 'mandantId', mandantId)
            const localVarPath = `/api/adressen/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mandantId !== undefined) {
                localVarQueryParameter['mandant_id'] = mandantId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adresse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Adressen anhand der Suchkriterien
         * @summary Adresssuche
         * @param {string} [query] Search Query
         * @param {number} [page] Page
         * @param {number} [searchLimit] Search Limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdressen: async (query?: string, page?: number, searchLimit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/adressen/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (searchLimit !== undefined) {
                localVarQueryParameter['searchLimit'] = searchLimit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Adressen anhand der gegebenen Parameter
         * @summary Adresssuche
         * @param {number} [mandant] Mandant
         * @param {string} [fremdnummer] Adresse-Fremdnummer
         * @param {string} [name] Adresse-Name
         * @param {string} [lkz] Länderkennzeichen
         * @param {string} [plz] Postleitzahl
         * @param {string} [ortsname] Ortsname
         * @param {string} [strasse] Strasse
         * @param {number} [searchLimit] Search Limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdressenByParameter: async (mandant?: number, fremdnummer?: string, name?: string, lkz?: string, plz?: string, ortsname?: string, strasse?: string, searchLimit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/adressen/searchByParam`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mandant !== undefined) {
                localVarQueryParameter['mandant'] = mandant;
            }

            if (fremdnummer !== undefined) {
                localVarQueryParameter['fremdnummer'] = fremdnummer;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (lkz !== undefined) {
                localVarQueryParameter['lkz'] = lkz;
            }

            if (plz !== undefined) {
                localVarQueryParameter['plz'] = plz;
            }

            if (ortsname !== undefined) {
                localVarQueryParameter['ortsname'] = ortsname;
            }

            if (strasse !== undefined) {
                localVarQueryParameter['strasse'] = strasse;
            }

            if (searchLimit !== undefined) {
                localVarQueryParameter['searchLimit'] = searchLimit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ändern einer Adresse
         * @summary Adresse
         * @param {number} id 
         * @param {Adresse} [adresse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (id: number, adresse?: Adresse, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update', 'id', id)
            const localVarPath = `/api/adressen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adresse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdresseService - functional programming interface
 * @export
 */
export const AdresseServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdresseServiceAxiosParamCreator(configuration)
    return {
        /**
         * Erstellt eine neue Adresse.
         * @summary Adresse
         * @param {Adresse} [adresse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdresse(adresse?: Adresse, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adresse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdresse(adresse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Setzt eine Adresse auf \"unsichtbar\"
         * @summary Adresse
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdresse(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adresse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdresse(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Adresse für die angegebene Fremdnummer
         * @summary Adresse
         * @param {string} fremdnummer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdresseByFremdnummer(fremdnummer: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adresse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdresseByFremdnummer(fremdnummer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Adresse
         * @summary Adresse
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdresseById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adresse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdresseById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert die Adresse des Mandanten für den aktuellen Benutzer
         * @summary Adresse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdresseOfCurrentMandant(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adresse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdresseOfCurrentMandant(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert die aktuelle Adresse vom aktuellen Mandanten
         * @summary Adresse
         * @param {number} mandantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdresseOfMandant(mandantId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adresse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdresseOfMandant(mandantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Adressen für den angegebenen Mandanten
         * @summary Adresse
         * @param {number} mandantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdressenForMandant(mandantId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Adresse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdressenForMandant(mandantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Importiert eine Liste von Adresen für den angegebenen Mandanten (Admin-Funktion)
         * @summary Adresse
         * @param {number} mandantId 
         * @param {Array<Adresse>} [adresse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importAdressen(mandantId: number, adresse?: Array<Adresse>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Adresse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importAdressen(mandantId, adresse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Adressen anhand der Suchkriterien
         * @summary Adresssuche
         * @param {string} [query] Search Query
         * @param {number} [page] Page
         * @param {number} [searchLimit] Search Limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAdressen(query?: string, page?: number, searchLimit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Adresse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAdressen(query, page, searchLimit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Adressen anhand der gegebenen Parameter
         * @summary Adresssuche
         * @param {number} [mandant] Mandant
         * @param {string} [fremdnummer] Adresse-Fremdnummer
         * @param {string} [name] Adresse-Name
         * @param {string} [lkz] Länderkennzeichen
         * @param {string} [plz] Postleitzahl
         * @param {string} [ortsname] Ortsname
         * @param {string} [strasse] Strasse
         * @param {number} [searchLimit] Search Limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAdressenByParameter(mandant?: number, fremdnummer?: string, name?: string, lkz?: string, plz?: string, ortsname?: string, strasse?: string, searchLimit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Adresse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAdressenByParameter(mandant, fremdnummer, name, lkz, plz, ortsname, strasse, searchLimit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Ändern einer Adresse
         * @summary Adresse
         * @param {number} id 
         * @param {Adresse} [adresse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(id: number, adresse?: Adresse, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Adresse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(id, adresse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdresseService - factory interface
 * @export
 */
export const AdresseServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdresseServiceFp(configuration)
    return {
        /**
         * Erstellt eine neue Adresse.
         * @summary Adresse
         * @param {Adresse} [adresse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdresse(adresse?: Adresse, options?: any): AxiosPromise<Adresse> {
            return localVarFp.createAdresse(adresse, options).then((request) => request(axios, basePath));
        },
        /**
         * Setzt eine Adresse auf \"unsichtbar\"
         * @summary Adresse
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdresse(id: number, options?: any): AxiosPromise<Adresse> {
            return localVarFp.deleteAdresse(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Adresse für die angegebene Fremdnummer
         * @summary Adresse
         * @param {string} fremdnummer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdresseByFremdnummer(fremdnummer: string, options?: any): AxiosPromise<Adresse> {
            return localVarFp.getAdresseByFremdnummer(fremdnummer, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Adresse
         * @summary Adresse
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdresseById(id: number, options?: any): AxiosPromise<Adresse> {
            return localVarFp.getAdresseById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert die Adresse des Mandanten für den aktuellen Benutzer
         * @summary Adresse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdresseOfCurrentMandant(options?: any): AxiosPromise<Adresse> {
            return localVarFp.getAdresseOfCurrentMandant(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert die aktuelle Adresse vom aktuellen Mandanten
         * @summary Adresse
         * @param {number} mandantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdresseOfMandant(mandantId: number, options?: any): AxiosPromise<Adresse> {
            return localVarFp.getAdresseOfMandant(mandantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Adressen für den angegebenen Mandanten
         * @summary Adresse
         * @param {number} mandantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdressenForMandant(mandantId: number, options?: any): AxiosPromise<Array<Adresse>> {
            return localVarFp.getAdressenForMandant(mandantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Importiert eine Liste von Adresen für den angegebenen Mandanten (Admin-Funktion)
         * @summary Adresse
         * @param {number} mandantId 
         * @param {Array<Adresse>} [adresse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAdressen(mandantId: number, adresse?: Array<Adresse>, options?: any): AxiosPromise<Array<Adresse>> {
            return localVarFp.importAdressen(mandantId, adresse, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Adressen anhand der Suchkriterien
         * @summary Adresssuche
         * @param {string} [query] Search Query
         * @param {number} [page] Page
         * @param {number} [searchLimit] Search Limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdressen(query?: string, page?: number, searchLimit?: number, options?: any): AxiosPromise<Array<Adresse>> {
            return localVarFp.searchAdressen(query, page, searchLimit, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Adressen anhand der gegebenen Parameter
         * @summary Adresssuche
         * @param {number} [mandant] Mandant
         * @param {string} [fremdnummer] Adresse-Fremdnummer
         * @param {string} [name] Adresse-Name
         * @param {string} [lkz] Länderkennzeichen
         * @param {string} [plz] Postleitzahl
         * @param {string} [ortsname] Ortsname
         * @param {string} [strasse] Strasse
         * @param {number} [searchLimit] Search Limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAdressenByParameter(mandant?: number, fremdnummer?: string, name?: string, lkz?: string, plz?: string, ortsname?: string, strasse?: string, searchLimit?: number, options?: any): AxiosPromise<Array<Adresse>> {
            return localVarFp.searchAdressenByParameter(mandant, fremdnummer, name, lkz, plz, ortsname, strasse, searchLimit, options).then((request) => request(axios, basePath));
        },
        /**
         * Ändern einer Adresse
         * @summary Adresse
         * @param {number} id 
         * @param {Adresse} [adresse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(id: number, adresse?: Adresse, options?: any): AxiosPromise<Adresse> {
            return localVarFp.update(id, adresse, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdresseService - interface
 * @export
 * @interface AdresseService
 */
export interface AdresseServiceInterface {
    /**
     * Erstellt eine neue Adresse.
     * @summary Adresse
     * @param {Adresse} [adresse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseServiceInterface
     */
    createAdresse(adresse?: Adresse, options?: any): AxiosPromise<Adresse>;

    /**
     * Setzt eine Adresse auf \"unsichtbar\"
     * @summary Adresse
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseServiceInterface
     */
    deleteAdresse(id: number, options?: any): AxiosPromise<Adresse>;

    /**
     * Liefert eine Adresse für die angegebene Fremdnummer
     * @summary Adresse
     * @param {string} fremdnummer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseServiceInterface
     */
    getAdresseByFremdnummer(fremdnummer: string, options?: any): AxiosPromise<Adresse>;

    /**
     * Liefert eine Adresse
     * @summary Adresse
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseServiceInterface
     */
    getAdresseById(id: number, options?: any): AxiosPromise<Adresse>;

    /**
     * Liefert die Adresse des Mandanten für den aktuellen Benutzer
     * @summary Adresse
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseServiceInterface
     */
    getAdresseOfCurrentMandant(options?: any): AxiosPromise<Adresse>;

    /**
     * Liefert die aktuelle Adresse vom aktuellen Mandanten
     * @summary Adresse
     * @param {number} mandantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseServiceInterface
     */
    getAdresseOfMandant(mandantId: number, options?: any): AxiosPromise<Adresse>;

    /**
     * Liefert eine Liste von Adressen für den angegebenen Mandanten
     * @summary Adresse
     * @param {number} mandantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseServiceInterface
     */
    getAdressenForMandant(mandantId: number, options?: any): AxiosPromise<Array<Adresse>>;

    /**
     * Importiert eine Liste von Adresen für den angegebenen Mandanten (Admin-Funktion)
     * @summary Adresse
     * @param {number} mandantId 
     * @param {Array<Adresse>} [adresse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseServiceInterface
     */
    importAdressen(mandantId: number, adresse?: Array<Adresse>, options?: any): AxiosPromise<Array<Adresse>>;

    /**
     * Liefert eine Liste von Adressen anhand der Suchkriterien
     * @summary Adresssuche
     * @param {string} [query] Search Query
     * @param {number} [page] Page
     * @param {number} [searchLimit] Search Limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseServiceInterface
     */
    searchAdressen(query?: string, page?: number, searchLimit?: number, options?: any): AxiosPromise<Array<Adresse>>;

    /**
     * Liefert eine Liste von Adressen anhand der gegebenen Parameter
     * @summary Adresssuche
     * @param {number} [mandant] Mandant
     * @param {string} [fremdnummer] Adresse-Fremdnummer
     * @param {string} [name] Adresse-Name
     * @param {string} [lkz] Länderkennzeichen
     * @param {string} [plz] Postleitzahl
     * @param {string} [ortsname] Ortsname
     * @param {string} [strasse] Strasse
     * @param {number} [searchLimit] Search Limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseServiceInterface
     */
    searchAdressenByParameter(mandant?: number, fremdnummer?: string, name?: string, lkz?: string, plz?: string, ortsname?: string, strasse?: string, searchLimit?: number, options?: any): AxiosPromise<Array<Adresse>>;

    /**
     * Ändern einer Adresse
     * @summary Adresse
     * @param {number} id 
     * @param {Adresse} [adresse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseServiceInterface
     */
    update(id: number, adresse?: Adresse, options?: any): AxiosPromise<Adresse>;

}

/**
 * AdresseService - object-oriented interface
 * @export
 * @class AdresseService
 * @extends {BaseAPI}
 */
export class AdresseService extends BaseAPI implements AdresseServiceInterface {
    /**
     * Erstellt eine neue Adresse.
     * @summary Adresse
     * @param {Adresse} [adresse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseService
     */
    public createAdresse(adresse?: Adresse, options?: any) {
        return AdresseServiceFp(this.configuration).createAdresse(adresse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Setzt eine Adresse auf \"unsichtbar\"
     * @summary Adresse
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseService
     */
    public deleteAdresse(id: number, options?: any) {
        return AdresseServiceFp(this.configuration).deleteAdresse(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Adresse für die angegebene Fremdnummer
     * @summary Adresse
     * @param {string} fremdnummer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseService
     */
    public getAdresseByFremdnummer(fremdnummer: string, options?: any) {
        return AdresseServiceFp(this.configuration).getAdresseByFremdnummer(fremdnummer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Adresse
     * @summary Adresse
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseService
     */
    public getAdresseById(id: number, options?: any) {
        return AdresseServiceFp(this.configuration).getAdresseById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert die Adresse des Mandanten für den aktuellen Benutzer
     * @summary Adresse
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseService
     */
    public getAdresseOfCurrentMandant(options?: any) {
        return AdresseServiceFp(this.configuration).getAdresseOfCurrentMandant(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert die aktuelle Adresse vom aktuellen Mandanten
     * @summary Adresse
     * @param {number} mandantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseService
     */
    public getAdresseOfMandant(mandantId: number, options?: any) {
        return AdresseServiceFp(this.configuration).getAdresseOfMandant(mandantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Adressen für den angegebenen Mandanten
     * @summary Adresse
     * @param {number} mandantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseService
     */
    public getAdressenForMandant(mandantId: number, options?: any) {
        return AdresseServiceFp(this.configuration).getAdressenForMandant(mandantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Importiert eine Liste von Adresen für den angegebenen Mandanten (Admin-Funktion)
     * @summary Adresse
     * @param {number} mandantId 
     * @param {Array<Adresse>} [adresse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseService
     */
    public importAdressen(mandantId: number, adresse?: Array<Adresse>, options?: any) {
        return AdresseServiceFp(this.configuration).importAdressen(mandantId, adresse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Adressen anhand der Suchkriterien
     * @summary Adresssuche
     * @param {string} [query] Search Query
     * @param {number} [page] Page
     * @param {number} [searchLimit] Search Limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseService
     */
    public searchAdressen(query?: string, page?: number, searchLimit?: number, options?: any) {
        return AdresseServiceFp(this.configuration).searchAdressen(query, page, searchLimit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Adressen anhand der gegebenen Parameter
     * @summary Adresssuche
     * @param {number} [mandant] Mandant
     * @param {string} [fremdnummer] Adresse-Fremdnummer
     * @param {string} [name] Adresse-Name
     * @param {string} [lkz] Länderkennzeichen
     * @param {string} [plz] Postleitzahl
     * @param {string} [ortsname] Ortsname
     * @param {string} [strasse] Strasse
     * @param {number} [searchLimit] Search Limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseService
     */
    public searchAdressenByParameter(mandant?: number, fremdnummer?: string, name?: string, lkz?: string, plz?: string, ortsname?: string, strasse?: string, searchLimit?: number, options?: any) {
        return AdresseServiceFp(this.configuration).searchAdressenByParameter(mandant, fremdnummer, name, lkz, plz, ortsname, strasse, searchLimit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ändern einer Adresse
     * @summary Adresse
     * @param {number} id 
     * @param {Adresse} [adresse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdresseService
     */
    public update(id: number, adresse?: Adresse, options?: any) {
        return AdresseServiceFp(this.configuration).update(id, adresse, options).then((request) => request(this.axios, this.basePath));
    }
}
